import React from 'react';
import { useSelector } from 'react-redux';
import { isIterationsPeriodKeySelectedSelector } from 'state/selectors/ui-state';
import { Flex } from 'components/base/layout-components';
import BoldedValue from 'components/BoldedValue';
import { TitleWithGraphIcon } from 'components/TitleWithIcons';
import WorkBreakdownProgressBar from 'components/WorkBreakdownProgressBar';
import WorkBreakdownTrendPopper from './WorkBreakdownTrendPopper';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING, ARTICLE_IDS } from 'common/constants/constants';

//usage example in storybook src/stories/index.js line 301
const WorkBreakdown = ({
  headLine,
  configurations,
  trendData,
  onLinkIconClick
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isIterationsPeriodKeySelected = useSelector(
    isIterationsPeriodKeySelectedSelector
  );

  const handleClick = event => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.DASHBOARD,
      click_type: TRACKING.CLICK.WORK_BREAKDOWN_TREND
    });
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  return (
    <div className='px-4'>
      <Flex direction='column' width='100%'>
        <TitleWithGraphIcon
          isOpen={!!anchorEl}
          onLinkIconClick={onLinkIconClick}
          onClick={handleClick}
          title='Work Breakdown'
          articleId={ARTICLE_IDS.WORK_BREAKDOWN}
          mb='small'
          expandChartTooltip={'Work breakdown trend'}
          showTrends={isIterationsPeriodKeySelected}
        />
        <BoldedValue
          value={{ size: 'x-x-large', text: headLine.value }}
          description={{ size: 'small', text: headLine.description }}
          mb='big'
          dataCy='code-changes-total-value'
        />
        <WorkBreakdownProgressBar
          configurations={configurations}
          height='8rem'
        />
      </Flex>
      <WorkBreakdownTrendPopper
        anchorEl={anchorEl}
        data={trendData}
        onClose={() => setAnchorEl(null)}
      />
    </div>
  );
};

export default WorkBreakdown;
